import helpers from '../helpers';

export default (Vue) => {
  Object.defineProperty(Vue.prototype, '$helpers', {
    get() {
      helpers.$vue = this; // creates a reference to the current vue instance
      return helpers;
    },
  });
};
